import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface PrecisionGameState {
  attemptCounts: Record<string, number>;
  wonCollections: string[];
  setAttemptCount: (collection: string, count: number) => void;
  incrementAttemptCount: (collection: string) => void;
  addWonCollection: (collection: string) => void;
  removeWonCollection: (collection: string) => void;
  hasWonCollection: (collection: string) => boolean;
}

export const usePrecisionGameStore = create<PrecisionGameState>()(
  persist(
    (set, get) => ({
      attemptCounts: {},
      wonCollections: [],
      setAttemptCount: (collection, count) =>
        set((state) => ({
          attemptCounts: {
            ...state.attemptCounts,
            [collection]: count,
          },
        })),
      incrementAttemptCount: (collection) =>
        set((state) => ({
          attemptCounts: {
            ...state.attemptCounts,
            [collection]: (state.attemptCounts[collection] || 0) + 1,
          },
        })),
      addWonCollection: (collection) =>
        set((state) => {
          // Only add if not already in the array
          if (!state.wonCollections.includes(collection)) {
            return {
              wonCollections: [...state.wonCollections, collection],
            };
          }
          return state;
        }),
      removeWonCollection: (collection) =>
        set((state) => ({
          wonCollections: state.wonCollections.filter((c) => c !== collection),
        })),
      hasWonCollection: (collection) => {
        return get().wonCollections.includes(collection);
      },
    }),
    {
      name: "precision-game-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
